const IconWriteReview = (): JSX.Element => {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11.2147V14H2.78528L11 5.78528L8.21472 3L0 11.2147ZM13.751 3.44189C14.083 3.10983 14.083 2.57344 13.751 2.24138L11.7586 0.249042C11.4266 -0.0830141 10.8902 -0.0830141 10.5581 0.249042L9 1.80715L12.1928 5L13.751 3.44189Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconWriteReview;
